module.exports = __webpack_public_path__ + "img/wxew.5ed91200.svg";